export enum VitRegistrationStatus {
  ProvisionalRegistration = 1,
  FullRegistration = 2,
  IntendToApplySoon = 3,
  ApplicationInProgressWithTheVit = 4,
  PermissionToTeach = 5,
}
